(ns app.api-credential.usage
  "How a freshly created API credential is used: the base URL of the
   organization's API and a first request. Pure string functions, so
   `app.api-credential.create-modal` stays a thin layout and the texts
   can be tested."
  (:require [clojure.string :as str]))

(def placeholder-origin
  "The origin shown when the one of the current page is unknown or has
   no organization UUID, the same placeholder as in the API
   documentation."
  "https://ORG_UUID.storrito.com")

(defn org-origin?
  "Whether `origin` is served under an organization UUID, the first
   label of its host name, e.g. `https://ORG_UUID.storrito.com`. False
   for a host without one (localhost, a cell host), the same check as
   `storrito.api-v1-doc.core/api-base-url` makes on the server."
  [origin]
  (let [host (-> (or origin "")
                 (str/replace #"^https?://" "")
                 (str/replace #"[:/].*$" ""))
        label (first (str/split host #"\."))]
    (some? (parse-uuid (or label "")))))

(defn base-url
  "The base URL of the API of the organization served at `origin`, e.g.
   `https://ORG_UUID.storrito.com` -> `https://ORG_UUID.storrito.com/api/v1/`.
   The API runs on the host of the app, whose subdomain is the
   organization UUID. An origin without one gets the placeholder, as in
   the API documentation."
  [origin]
  (str (if (org-origin? origin) origin placeholder-origin) "/api/v1/"))

(defn token
  "The Bearer token of a credential: its id and its secret, separated by
   a colon. Only the result of the create command carries the secret,
   the credentials of the list query have none."
  [{:keys [api-credential/id api-credential/secret]}]
  (str id ":" secret))

(defn curl-example
  "A ready-to-paste request against `generate-uuid`, the simplest
   procedure, with the real base URL and the real token. Written for
   bash: the line continuations and the quoting do not work in cmd or
   PowerShell."
  [{:keys [origin token]}]
  (str "curl -X POST " (base-url origin) "generate-uuid \\\n"
       "  -H \"Authorization: Bearer " token "\" \\\n"
       "  -H \"Content-Type: application/json\" \\\n"
       "  -d '{}'"))
